import ObjectCreate from './component'

export default ObjectCreate
